<template>
  <div>
    <div class="history-purchase__header">
      <div class="history-purchase__header-actions">
        <div class="search-filter">
          <b-icon-search />
          <input
            :value="getSearchValue"
            type="text"
            autocomplete="off"
            name="search-box"
            :placeholder="$t(toggleSearchArticles)"
            @input="handleSearchInput"
          >
          <b-icon-x-circle
            class="search-filter__clear"
            :class="{ 'search-filter__clear--active': getSearchValue !== '' }"
            @click="clearSearch"
          />
          <b-form-select
            v-model="toggleSearchArticles"
            :options="options"
            class="search-filter__select"
            @change="callToggle(toggleSearchArticles)"
          />
          <div
            v-if="getArticleNameLike.length > 0 && toggleSearchArticles === 'ArticleNumber'"
            ref="scrollContainer"
            class="search-filter__dropdown"
            :style="getArticleNameLike.length > 7 ? 'height: 210px' : 'height: auto'"
          >
            <div
              v-for="(result, index) in getArticleNameLike"
              :key="index"
              ref="options"
              style="cursor: pointer"
              class="search-item"
              :class="{ 'is-active': index === arrowCounter }"
              @click="searchByOnArticles(result);"
            >
              <p style="margin: 0">
                {{ result.articleNumber }}
              </p>
            </div>
          </div>
          <div
            v-if="getFilteredDresses.length > 0 && toggleSearchArticles === 'Code'"
            ref="scrollContainer"
            class="search-filter__dropdown"
            :style="getFilteredDresses.length > 7 ? 'height: 210px' : 'height: auto'"
          >
            <div
              v-for="(result, index) in getFilteredDresses"
              :key="index"
              ref="options"
              style="cursor: pointer"
              class="search-item"
              :class="{ 'is-active': index === arrowCounter }"
              @click="searchByCodeArticles(result);"
            >
              <p style="margin: 0">
                {{ result.name + (result.code ? ' ' + result.code : '') }}
              </p>
            </div>
          </div>
          <div
            v-if="getFilteredDresses.length > 0 && toggleSearchArticles === 'Category'"
            ref="scrollContainer"
            class="search-filter__dropdown"
            :style="getFilteredDresses.length > 7 ? 'height: 210px' : 'height: auto'"
          >
            <div
              v-for="(result, index) in getFilteredDresses"
              :key="index"
              ref="options"
              style="cursor: pointer"
              class="search-item"
              :class="{ 'is-active': index === arrowCounter }"
              @click="searchByCategoryArticles(result);"
            >
              <p style="margin: 0">
                {{ result.name + (result.code ? ' ' + result.code : '') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="history-purchase__header-filters">
        <label>
          <p>{{ $t('StartDate') }}</p>
          <date-picker
            v-model="startDate"
            type="date"
            format="YYYY-MM-DD"
            value-type="format"
            :placeholder="$t('SelectD')"
            :clearable="false"
            class="history-purchase__header-filters--input"
          />
        </label>
        <label>
          <p>{{ $t('EndDate') }}</p>
          <date-picker
            v-model="endDate"
            type="date"
            format="YYYY-MM-DD"
            value-type="format"
            :placeholder="$t('SelectD')"
            :clearable="false"
            class="history-purchase__header-filters--input"
          />
        </label>
        <img
          v-if="getDeliveryTrackingArticles.length > 0"
          style="cursor:pointer;"
          src="../../assets/images/pdf-invoice-logo.svg"
          @click="downloadPDF"
        >
        <button
          v-if="getDeliveryTrackingArticles.length > 0"
          style="    border: 0;
                width: 28px;
                height: 28px; background: #FF274F; border-radius: 5px;"
          @click="downloadEXCEL"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="white"
            class="bi bi-file-earmark-spreadsheet"
            viewBox="0 0 16 16"
          >
            <path
              d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h3v2H6zm4 0v-2h3v1a1 1 0 0 1-1 1h-2zm3-3h-3v-2h3v2zm-7 0v-2h3v2H6z"
            />
          </svg>
        </button>
      </div>
    </div>
    <div
      class="tt"
    >
      <table
        class="team_table"
      >
        <thead>
          <tr>
            <th>{{ $t('DeliveryNumber') }}</th>
            <th>{{ $t('ArticleNumber') }}</th>
            <th>{{ $t('InvoiceNumber') }}</th>
            <th>{{ $t('Amount') }}</th>
            <th>{{ $t('TaxRate') }}</th>
            <th>{{ $t('TotalPrice') }}</th>
            <th>{{ $t('SupplierName') }}</th>
            <th>{{ $t('BalanceStock') }}</th>
            <th>{{ $t('ReceiverLocation') }}</th>
            <th>{{ $t('fileUrls') }}</th>
            <th>{{ $t('DateOfInvoice') }}</th>
            <th>{{ $t('Created') }}</th>
          </tr>
        </thead>
        <LoadingSpinnerTable
          :is-loading="isRequestLoading('loadDeliveryTrackingArticles')"
          :cols="24"
          :response-data="getDeliveryTrackingArticles"
        >
          <tr
            v-for=" (item,index) in getDeliveryTrackingArticles"
            :key="index"
          >
            <td> {{ item.deliveryNumber }}</td>
            <td> {{ item.articleNumber }}</td>
            <td> {{ item.invoiceNumber }}</td>
            <td> {{ item.quantity }}</td>
            <td> {{ item.taxRate }}</td>
            <td> {{ item.totalPrice }}</td>
            <td> {{ item.supplierName }}</td>
            <td> {{ item.balanceStock }}</td>
            <td> {{ item.receiverLocationName }}</td>
            <td
              v-if="item.fileUrls.length > 0"
              style="display: flex; flex-wrap: wrap; gap: 3px;"
            >
              <template v-for="(photo, photoIndex) in item.fileUrls">
                <img
                  v-if="photo.endsWith('.pdf') || photo.endsWith('.docx') || photo.endsWith('.xlsm') || photo.endsWith('.xlsx') || photo.endsWith('.plain')"
                  :key="'doc-' + photoIndex"
                  v-b-tooltip="$t('Document')"
                  style="width:30px;height:30px"
                  src="../../assets/images/documentLogo.svg"
                >
                <button
                  v-if="photo.endsWith('.pdf') || photo.endsWith('.docx') || photo.endsWith('.xlsm') || photo.endsWith('.xlsx') || photo.endsWith('.plain')"
                  :key="'btn-' + photoIndex"
                  v-b-tooltip="$t('Download')"
                  style="border: 1px solid #FF274F; width: 35px; height: 35px; background: white; border-radius: 5px; margin-right: 10px;"
                  @click.stop="downloadFile(photo)"
                >
                  <b-icon-download style="color: #FF274F;" />
                </button>

                <img
                  v-if="!photo.endsWith('.pdf') && !photo.endsWith('.docx') && !photo.endsWith('.xlsm') && !photo.endsWith('.xlsx') && !photo.endsWith('.plain')"
                  :key="'img-' + photoIndex"
                  v-b-tooltip="$t('ClickToViewPhoto')"
                  style="width:30px;height:30px; border-radius: 3px;"
                  :src="photo"
                  alt="No image"
                >
                <button
                  v-if="!photo.endsWith('.pdf') && !photo.endsWith('.docx') && !photo.endsWith('.xlsm') && !photo.endsWith('.xlsx') && !photo.endsWith('.plain')"
                  :key="'img-btn-' + photoIndex"
                  v-b-tooltip="$t('Download')"
                  style="border: 1px solid #FF274F; width: 35px; height: 35px; background: white; border-radius: 5px; margin-right: 10px;"
                  @click.stop="downloadFile(photo)"
                >
                  <b-icon-download style="color: #FF274F;" />
                </button>
              </template>
            </td>
            <td v-else>
              <img
                v-b-tooltip="$t('NoImageOrDocument')"
                style="width:30px;height:30px"
                src="../../assets/images/noImageAvailable.svg"
              >
            </td>
            <td> {{ formatDate(item.invoiceDate) }}</td>
            <td> {{ formatDate(item.created) }}</td>
          </tr>
        </LoadingSpinnerTable>
      </table>
      <div>
        <b-pagination
          v-if="getTotalItemsTrackingArticles > 15"
          v-model="pageNumber"
          :total-rows="getTotalItemsTrackingArticles"
          :per-page="pageSize"
          first-number
          last-number
          align="fill"
          size="md"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
          </template>
          <template #next-text>
            <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import jsPDF from 'jspdf';
import 'vue2-datepicker/index.css';
import 'jspdf-autotable';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { client } from '../../domainConfig'



export default {
  components: {
    DatePicker,
  },
  props: [],
  data() {
    return {
      client: client.clientName,
      startDate: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      endDate: moment()
        .format('YYYY-MM-DD'),
      toggleSearch: 'MaterialName',
      noSearch: false,
      searchCode: '',
      searchMaterial: '',
      arrowCounter: 0,
      enterPressed: false,
      skipWatch: false,
      pageNumber: 1,
      pageSize: 15,
      totalPriceForOrder: 0,
      totalAmountForOrder: 0,
      toggleSearchArticles: 'ArticleNumber',
      options: [
        { value: 'ArticleNumber', text: this.$t('ArticleNumber') },
        { value: 'Code', text: this.$t('Code') },
        { value: 'Category', text: this.$t('Category') },
      ],
      searchArticle: '',
      searchCodeArticles: '',
      searchCategoryArticles: '',
      searchArticleId: null,
      searchCodeArticlesId: null,
      searchCategoryArticlesId: null,
    }
  },
  computed: {
    ...mapGetters(['getVariantsDropdownByName',
      'getDeliveryTrackingArticles',
      'getTotalItemsTrackingArticles',
      'getTotalPagesArticlesTracking',
      'getMaterials',
      'getIsLoading',
      'getCurrentPageForMaterials',
      'getTotalItemsForMaterials',
      'getMatVarCurrentPage',
      'getTotalPriceByMaterialId',
      'getVariantsDropdownByCode',
      'getSupplierDropDown',
      'getAccountDetails',
      'getLocationsMoving',
      'getTotalPagesForAll',
      'getArticleNameLike',
      'getFilteredDresses',
    ]),
    getSearchValue() {
      switch (this.toggleSearchArticles) {
        case 'ArticleNumber':
          return this.searchArticle
        case 'Code':
          return this.searchCodeArticles
        case 'Category':
          return this.searchCategoryArticles
        default:
          return ''
      }
    },
  },
  watch: {
    pageNumber(value) {
      if (value) {
        this.loadDeliveryTrackingArticles({
          inventoryProductId: this.searchArticleId || this.searchCategoryArticlesId || this.searchCodeArticlesId,
          startDate: this.startDate,
          endDate: this.endDate,
          pageNumber: value,
          pageSize: this.pageSize,
        })
      }
    },
    searchArticle(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeListsArticles();
          this.loadDeliveryTrackingArticles({
            startDate: this.startDate,
            endDate: this.endDate,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
        } else if (!this.enterPressed) {
          this.productInStock_articleNumberLike(value);
        }
      }, 500);
    },
    searchCodeArticles(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeListsArticles();
          this.loadDeliveryTrackingArticles({
            startDate: this.startDate,
            endDate: this.endDate,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
        } else if (!this.enterPressed) {
          this.filteredDressesByName({
            code: value,
            name: null,
          });
        }
      }, 500);
    },
    searchCategoryArticles(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeListsArticles();
          this.loadDeliveryTrackingArticles({
            startDate: this.startDate,
            endDate: this.endDate,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
        } else if (!this.enterPressed) {
          this.filteredDressesByName({
            code: null,
            name: value,
          });
        }
      }, 500);
    },
    startDate(value) {
      if (value > this.endDate) {
        this.endDate = value
      }
      this.loadDeliveryTrackingArticles({
        inventoryProductId: this.searchArticleId || this.searchCategoryArticlesId || this.searchCodeArticlesId,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
    },
    endDate(value) {
      if (value < this.startDate) {
        this.startDate = value
      }
      this.loadDeliveryTrackingArticles({
        inventoryProductId: this.searchArticleId || this.searchCategoryArticlesId || this.searchCodeArticlesId,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
    },
  },
  mounted() {
    this.loadDeliveryTrackingArticles({
      inventoryProductId: this.searchArticleId || this.searchCategoryArticlesId || this.searchCodeArticlesId,
      startDate: this.startDate,
      endDate: this.endDate,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    })
  },
  methods: {
    ...mapActions([
      'variantsByDropdownName',
      'resetVariantsName',
      'variantsByDropdownCode',
      'resetVariantsCode',
      'loadHistoryMaterialVariant',
      'loadDeliveryTrackingArticles',
      'resetHistoryMaterialVariant',
      'totalPriceByMaterialId',
      'resetMaterialVariant',
      'variantsByDropdownName',
      'addMaterial',
      'loadMaterials',
      'editMaterialReq',
      'loadMaterialVariant',
      'addMaterialVariant',
      'changeLoadingtoTrue',
      'resetVariantsName',
      'variantsByDropdownCode',
      'resetVariantsCode',
      'receiveVariantsAndPurchase',
      'loadSuppliers',
      'loadColors',
      'resetProductInStock',
      'resetFilteredDresses',
      'filteredDressesByName',
      'productInStock_articleNumberLike',
      'locationPagination',
    ]),
    handleSearchInput(e) {
      switch (this.toggleSearchArticles) {
        case 'ArticleNumber':
          this.searchArticle = e.target.value
          break
        case 'Code':
          this.searchCodeArticles = e.target.value
          break
        case 'Category':
          this.searchCategoryArticles = e.target.value
          break
        default:
          break
      }
    },
    clearSearch() {
      switch (this.toggleSearchArticles) {
        case 'ArticleNumber':
          this.searchArticle = ''
          break
        case 'Code':
          this.searchCodeArticles = ''
          break
        case 'Category':
          this.searchCategoryArticles = ''
          break
        default:
          break
      }
    },
    downloadFile(fileUrl) {
      // This method will handle both download and preview of the file
      const fileExtension = fileUrl.split('.')
        .pop();

      // If the file is already a PDF, no need to generate it
      if (fileExtension === 'pdf') {
        this.generateAndPreviewPdf(fileUrl);
      } else {
        // If the file is not a PDF, handle the conversion if needed
        // You can add specific logic for .docx, .xlsx, etc. if required
        console.log('Downloading non-PDF file:', fileUrl);

        // Handle the logic to download or preview non-PDF files here (optional)
        this.downloadNonPdfFile(fileUrl); // Custom method to handle this
      }
    },
    generateAndPreviewPdf(pdfUrl) {
      // Generate a Blob from the URL
      fetch(pdfUrl)
        .then((response) => {
          return response.blob()
        })
        .then((pdfBlob) => {
          const blobUrl = URL.createObjectURL(pdfBlob);
          // Save the Blob URL to sessionStorage
          sessionStorage.setItem('pdfBlobUrl', blobUrl);
          sessionStorage.setItem('pathName', this.$route.path);
          this.$router.push({ name: 'Pdf Preview' }); // Ensure you have a route named 'PdfPreview'
        })
        .catch((error) => {
          console.error('Error generating PDF:', error);
        });
    },

    // getOrderedMaterialPagination

    downloadNonPdfFile(fileUrl) {
      // For non-PDF files, you can either download or display them differently
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = true; // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    callToggle(value) {
      this.toggleSearchArticles = value
      this.searchCodeArticles = ''
      this.searchCategoryArticles = ''
      this.searchArticle = ''
      this.searchCodeArticlesId = null
      this.searchCategoryArticlesId = null
      this.searchArticleId = null
      this.removeListsArticles()
    },
    formatDate(value) {
      let parameter
      if (value != null) {
        parameter = moment(value)
          .format('YYYY-MM-DD')
      }
      return parameter
    },
    inputChangedArticles(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') {
        return;
      }
      // this.getArticleNameLike = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByOnArticles(this.getArticleNameLike[this.arrowCounter])
        this.removeListsArticles()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    onArrowDownArticles(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getArticleNameLike.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUpArticles(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    inputChangedCategory(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') {
        return;
      }
      // this.getArticleNameLike = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByCategoryArticles(this.getFilteredDresses[this.arrowCounter])
        this.removeListsArticles()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    onArrowDownCategory(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFilteredDresses.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUpCategory(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    inputChangedCodeArticles(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') {
        return;
      }
      // this.getFilteredDresses = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByCodeArticles(this.getFilteredDresses[this.arrowCounter])
        this.removeListsArticles()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    onArrowDownCodeArticles(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFilteredDresses.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUpCodeArticles(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    async searchByOnArticles(value) {
      this.loadDeliveryTrackingArticles({
        inventoryProductId: value.inventoryId,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
      this.skipWatch = true;
      this.searchArticle = value.articleNumber;
      this.searchArticleId = value.inventoryId
      this.resetProductInStock();
    },
    async searchByCodeArticles(value) {
      this.loadDeliveryTrackingArticles({
        inventoryProductId: value.mainDressCategoryId,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
      this.skipWatch = true;
      this.searchCodeArticles = value.name;
      this.searchCodeArticlesId = value.mainDressCategoryId
      this.resetFilteredDresses();
    },
    async searchByCategoryArticles(value) {
      this.loadDeliveryTrackingArticles({
        inventoryProductId: value.mainDressCategoryId,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
      this.skipWatch = true;
      this.searchCategoryArticles = value.name;
      this.searchCategoryArticlesId = value.mainDressCategoryId
      this.resetFilteredDresses();
    },
    removeListsArticles() {
      this.resetProductInStock()
      this.resetFilteredDresses()
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      console.log(liH)
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
    downloadEXCEL() {
      this.loadDeliveryTrackingArticles({
        inventoryProductId: this.searchArticleId || this.searchCategoryArticlesId || this.searchCodeArticlesId,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
        .then(() => {
          const tableContent = this.generateTableContent(this.getDeliveryTrackingArticles);
          const totalPages = this.getTotalPagesArticlesTracking;
          const additionalPromises = [];
          for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
            additionalPromises.push(this.downloadPage(pageNumber));
          }

          Promise.all(additionalPromises)
            .then((additionalTableContents) => {
              additionalTableContents.forEach((additionalTableContent) => {
                tableContent.body = tableContent.body.concat(additionalTableContent.body);
              });
              const excelData = this.generateExcel(tableContent);
              FileSaver.saveAs(excelData, `${this.$t('HistoryBuyDirect')}-${moment()
                .format('DD/MM/YYYY - hh:mm:s')}`);
            });
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    generateExcel(tableContent) {
      const {
        headers,
        body,
      } = tableContent;
      const sheetData = [headers, ...body];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      const excelData = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      return excelData;
    },
    downloadPDF() {
      this.totalPriceForOrder = 0
      this.totalAmountForOrder = 0
      this.loadDeliveryTrackingArticles({
        inventoryProductId: this.searchArticleId || this.searchCategoryArticlesId || this.searchCodeArticlesId,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
        .then(() => {
          const tableContent = this.generateTableContent(this.getDeliveryTrackingArticles);

          const totalPages = this.getTotalPagesArticlesTracking;
          const additionalPromises = [];
          for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
            additionalPromises.push(this.downloadPage(pageNumber));
          }

          Promise.all(additionalPromises)
            .then((additionalTableContents) => {
              additionalTableContents.forEach((additionalTableContent) => {
                tableContent.body.push(...additionalTableContent.body);
              });

              const footerIcon = 'data:image/png;base64,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'
              const xharraIcon = 'data:image/png;base64,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'
              const digitIcon = 'data:image/png;base64,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'
              const pdfDocument = this.generatePDF(tableContent, footerIcon, xharraIcon, digitIcon, 800);
              pdfDocument.save(`${this.$t('HistoryBuyDirect')}-${moment()
                .format('DD/MM/YYYY - hh:mm:s')}.pdf`);
            });
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    generateTableContent(items) {
      const headers = [
        `${this.$t('DeliveryNumber')}`,
        `${this.$t('ArticleNumber')}`,
        `${this.$t('InvoiceNumber')}`,
        `${this.$t('Amount')}`,
        `${this.$t('TaxRate')}`,
        `${this.$t('TotalPrice')}`,
        `${this.$t('SupplierName')}`,
        `${this.$t('BalanceStock')}`,
        `${this.$t('ReceiverLocation')}`,
        `${this.$t('DateOfInvoice')}`,
        `${this.$t('Created')}`,
      ];
      const body = items.map((item) => {
        this.totalPriceForOrder = item.totalPrice + this.totalPriceForOrder
        this.totalAmountForOrder = item.quantity + this.totalAmountForOrder
        return [
          item.deliveryNumber,
          item.articleNumber,
          item.invoiceNumber,
          item.quantity,
          item.taxRate,
          item.totalPrice,
          item.supplierName,
          item.balanceStock,
          item.receiverLocationName,
          this.formatDate(item.invoiceDate),
          this.formatDate(item.created),
        ]
      });

      return {
        headers,
        body,
      };
    },
    downloadPage(pageNumber) {
      return this.loadDeliveryTrackingArticles({
        inventoryProductId: this.searchArticleId || this.searchCategoryArticlesId || this.searchCodeArticlesId,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber,
        pageSize: this.pageSize,
      })
        .then(() => {
          return this.generateTableContent(this.getDeliveryTrackingArticles);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    generatePDF(tableContent, footerIcon, xharraIcon, digitIcon, customWidth) {
      const {
        headers,
        body,
      } = tableContent;


      // eslint-disable-next-line new-cap
      const doc = new jsPDF({
        orientation: 'landscape', // Set the orientation to landscape if you want a wider document
        unit: 'pt', // Use points as the unit of measurement
      });

      // Set custom width after creating the doc instance
      doc.setProperties({
        format: [customWidth, doc.internal.pageSize.getHeight()], // Set custom width
      });
      const iconWidth = 90; // Adjust the width of the icon as needed
      const iconHeight = 120; // Adjust the height of the icon as needed
      const iconY = 0; // Adjust the vertical position of the icon (top)
      // Draw a blue background rectangle that spans the entire width of the paper
      const blueBackgroundX = 0;
      const blueBackgroundWidth = doc.internal.pageSize.getWidth();
      const blueBackgroundHeight = 65; // Adjust the height as needed
      doc.setFillColor(255, 255, 255); // Blue color
      doc.rect(blueBackgroundX, 0, blueBackgroundWidth, blueBackgroundHeight, 'F');

      const iconX = 40; // Adjust the horizontal position of the icon (left)
      doc.addImage(xharraIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

      const staticContent = () => {
        const blueBackgroundFooterX = 0;
        const blueBackgroundFooterY = doc.internal.pageSize.getHeight() - 45;
        const blueBackgroundFooterWidth = doc.internal.pageSize.getWidth();
        const blueBackgroundFooterHeight = 45;
        doc.setFillColor(255, 39, 79); // Blue color (RGB values)
        doc.rect(blueBackgroundFooterX, blueBackgroundFooterY, blueBackgroundFooterWidth, blueBackgroundFooterHeight, 'F');

        // Add URL
        let url;
        let address;
        if (this.client == 'NotaBrillant') {
          url = 'www.nota-brillant.com'
          address = 'Prishtinë-Ferizaj highway 4km, Prishtinë, Kosova'
        } else {
          url = 'http://localhost:8080/';
          address = 'Spim Fashion Group';
        }
        const urlX = doc.internal.pageSize.getWidth() - 800
        const urlY = doc.internal.pageSize.getHeight() - 25;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(url, urlX, urlY, { align: 'left' });

        // Add address

        const addressX = doc.internal.pageSize.getWidth() - 800
        const addressY = doc.internal.pageSize.getHeight() - 10;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(address, addressX, addressY, { align: 'left' });

        const digitIconWidth = 50;
        const digitIconHeight = 20;
        const digitIconY = doc.internal.pageSize.getHeight() - 35;
        const digitIconX = doc.internal.pageSize.getWidth() - 120;

        // Add text before digitIcon
        const textBeforeDigitIcon = 'Powered By';
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        const textY = doc.internal.pageSize.getHeight() - 20;
        const textX = doc.internal.pageSize.getWidth() - 180;

        doc.text(textBeforeDigitIcon, textX, textY);

        // Add the digitIcon
        doc.addImage(digitIcon, 'PNG', digitIconX, digitIconY, digitIconWidth, digitIconHeight);
      };

      const totalX = doc.internal.pageSize.getWidth() - 38;
      const totalY = 150;
      doc.setFontSize(12);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('TotalPrice')}: ${this.totalPriceForOrder.toFixed(2)
        .toString()}`, totalX, totalY, { align: 'right' });

      const totalY1 = 130;
      doc.setFontSize(12);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('TotalAmount')}: ${this.totalAmountForOrder.toFixed(2)
        .toString()}`, totalX, totalY1, { align: 'right' });

      const totalY19 = 110;
      doc.setFontSize(12);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('EndDate')}: ${this.endDate}`, totalX, totalY19, { align: 'right' });

      const totalY199 = 90;
      doc.setFontSize(12);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('StartDate')}: ${this.startDate}`, totalX, totalY199, { align: 'right' });

      const titleP = `${this.$t('PurchaseHistory')}`;
      const titleYP = doc.internal.pageSize.getHeight() - 550;
      const titleXP = doc.internal.pageSize.getWidth() - 38;
      doc.setFontSize(21);
      doc.setFont('Arial', 'bold');
      doc.setTextColor(11, 19, 84);
      doc.text(titleP, titleXP, titleYP, { align: 'right' });

      // Add the title
      const title = `${this.searchArticle || this.searchCodeArticles || this.searchCategoryArticles ? `${this.$t('ArticleNumber')}:` : ''} ${this.searchArticle || this.searchCodeArticles || this.searchCategoryArticles}`;
      const titleY = doc.internal.pageSize.getHeight() - 520;
      const titleX = doc.internal.pageSize.getWidth() - 38;
      doc.setFontSize(21);
      doc.setFont('Arial', 'bold');
      doc.setTextColor(11, 19, 84);
      doc.text(title, titleX, titleY, { align: 'right' });

      doc.setFont('Arial', 'normal');

      // Add the author
      const authorX = 150;
      const authorY = 76;
      doc.setFontSize(22);
      doc.setTextColor(11, 19, 84);
      doc.text(this.client, authorX, authorY);

      // const author2X = 150;
      // const author2Y = 100;
      // doc.setFontSize(16);
      // doc.setTextColor(11, 19, 84);
      // doc.text(`${this.$t('Spim Dega në Kosovë')}`, author2X, author2Y);

      const author3X = 40;
      const author3Y = 150;
      doc.setFontSize(15);
      doc.setFont('Arial', 'bold');
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.$t('From')}:`, author3X, author3Y);

      doc.setFont('Arial', 'normal');

      const author4X = 92;
      const author4Y = 150;
      doc.setFontSize(15);
      doc.setTextColor(11, 19, 84);
      doc.text(`${this.client}`, author4X, author4Y);

      // Add the table
      const tableOptions = {
        startY: authorY + 100, // Adjust the vertical position of the table
        time: moment()
          .format('DD-MM-YYYY'),
        head: [headers],
        body,
        headStyles: {
          fillColor: [234, 236, 240],
          textColor: [11, 19, 84],
          halign: 'left',
        },
        bodyStyles: {
          textColor: [26, 26, 26],
          lineWidth: 0.1,
          lineColor: [234, 236, 240],
        },
        afterPageContent: staticContent,
      };
      doc.autoTable(tableOptions);

      return doc;
    },
  },
}
</script>

<style scoped lang="scss">
.history-purchase__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 18px 0;
  padding-top:5px;
  align-items:flex-end;
}

.history-purchase__header-actions {
  display: flex;
  align-items: center;
  margin-right: 20px;
  position: relative;

  .search-filter {
    max-width: 358px !important;
  }

  .search-filter__select {
    max-width: 148px !important;
    width: 100% !important;
  }

  button {
    margin-left: 20px;
    width: 135px !important;
    height: 36px !important;
  }
}

@media screen and (max-width: 768px) {
  .history-purchase__header-actions {
    width: 100%;
  }
}

.history-purchase__header-filters {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;

  &--input {
    width: 196px;
    min-height: 32px !important;
  }

  label {
    p {
      font-size: 12px;
      font-weight: 500;
      color: #707070;
      margin: 0 !important;
      white-space: nowrap;
    }
  }

  :deep(.vs__search) {
    max-width: 136px !important;
    width: 100% !important;
    padding: 0 7px !important;
    color: rgb(112, 112, 112);
  }

  :deep(.vs__selected-options) {
    display: flex;
    flex-wrap: nowrap;
  }
}

.search-filter__dropdown {
  position: absolute;
  max-width: 358px;
  width: 100%;
  top: 36px;
  left: 0;
  background: white;
}

.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 400;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}

.search-item:last-child {
  border-bottom: none;
}

.search-item:hover {
  background: #82868c;
  color: white;
}

.form-control {
  width: 193px;
  border: none;
}

.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}

.active2 {
  font-weight: bold;
  color: $base-color;
}

.team_table td {
  padding: 22px 9px !important;
}

.buttonOrdered {
  border: none;
}

.buttonOrdered:hover {
  background: white;
  color: #FF274F;
}


.team_table thead {
  border-bottom: 1px solid #dcdfe6;
  color: #606266;
  text-align: left;
}

.team_table tr {
  border-bottom: 1px solid #dcdfe6;
  color: #606266;
  cursor: pointer;
}

.hover-row:hover {
  background-color: rgba(255, 39, 79, 0.1);
}

.mats-listing__wrapper {
  width: 600px !important;

  .tt {
    .vgt-table {
      th.sortable button {
        display: none !important;
      }
    }
  }

  .mats-listing {
    margin-top: 0;
  }
}

.button {
  margin-bottom: 15px !important;
  width: 195px;
}

// .team_table .tr{
//   border-radius: 10px 10px 10px 10px !important;
// }


@media screen and (max-width: 1723px) {
  .mats-listing__wrapper {
    width: 400px !important;

    div {
      button {
        width: auto;
        height: 36px;
      }

      input {
        width: 160px;
      }

    }

    .table__search-input {
      padding-left: 0px;
      margin-left: 0px !important;
    }
  }

}

@media screen and (max-width: 1400px) {
  .mats-listing__wrapper {
    width: 100% !important;
  }
}


.dropdrop::-webkit-scrollbar {
  display: none;

}

.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: none;
}

input[name="search-box"] {
  display: block;
  max-width: 500px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}

.black {
  position: relative;
}


.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 400;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}

.search-item:last-child {
  border-bottom: none;
}

.search-item:hover {
  background: #82868c;
  color: white;
}

.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}

.bigger-icon {
  font-size: 24px;
  align-self: center;
}

.photo {
  margin-left: 5px;
  height: 50px;
  border-radius: 8px;
}

.year {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.arrowButton {
  width: 36px !important;
  height: 36px;
  display: flex;
  margin-right: 5px;
  border-radius: 6px !important;
  justify-content: center;
  border: #c3d0dd 1px solid;
  background-color: #e9ecef;
  align-items: center;
}

.hovered {
  /* Additional styles for the hovered photo */
  transform: scale(7.2);
  border-radius: 0px;
}

.second-photo {
  margin-left: 10px;
}

.third-photo {
  margin-left: 10px;
}

.is-active {
  background-color: #dedede;
}
</style>
